var fluidvids = require('./fluidvids');

fluidvids.init({
        selector: ['iframe', 'object'], // runs querySelectorAll()
        players: ['www.youtube.com', 'player.vimeo.com','www.facebook.com/plugins/video.php','twitter.com/i/videos'] // players to support
});

